import React, { useState, useEffect } from 'react';
import { Col, Row, Skeleton, Tooltip } from 'antd';
import moment from 'moment';
import {
  GUTTOR_SPACE_SMALL,
  COMMON_DATE_FORMAT,
  GUTTOR_SPACE,
  TOOLTIP_TEXT,
  authFeatureConstants,
} from '../../../../../shared/constants/commonConstants';
import SaveAccountDetail from './SaveAccountDetail';
import { useSelector } from 'react-redux';
import Panel from './../../../../../shared/components/card/Panel';
import { ReactComponent as EditIcon } from '../../../../../assets/images/svg/i_edit.svg';
import { ReactComponent as CloseIcon } from '../../../../../assets/images/svg/i_close.svg';
import { canActivate, GetFirstElement } from '../../../../../utils/utility';

const AccountDetail = (): any => {
  const [isShowSaveComponent, setIsShowSaveComponent] = useState(Boolean);
  const [profileDetail, setProfileDetailHandler] = useState(null as any);
  const [profileData, setProfileData] = useState(null as any);
  const [bankData, setBankData] = useState(null as any);
  const [registrationData, setRegistrationData] = useState(null as any);
  const apiHospitalProfile = useSelector(
    ({ hospital: { hospitalProfile } }: any): any => hospitalProfile,
  );
  const isNewEntry = useSelector(
    ({ hospital: { newEntry } }: any): any => newEntry,
  );
  useEffect((): void => {
    if (
      apiHospitalProfile &&
      apiHospitalProfile.length > 0 &&
      apiHospitalProfile[0]
    ) {
      setIsShowSaveComponent(false);
      const [data]: any = apiHospitalProfile || [];
      setProfileDetailHandler(data);
    }
  }, [apiHospitalProfile]);

  useEffect((): void => {
    if (profileDetail) {
      setProfileData(profileDetail);
      setBankData(GetFirstElement(profileDetail?.bankDetails));
      setRegistrationData(GetFirstElement(profileDetail?.registrationDetails));
    }
  }, [profileDetail]);

  const editHandleClick = (): void => {
    setIsShowSaveComponent(!isShowSaveComponent);
  };

  return (
    <Row gutter={GUTTOR_SPACE}>
      <Col md={24}>
        <Panel
          title="Registration and Account Details"
          // eslint-disable-next-line
          extra={
            (!isNewEntry && canActivate(authFeatureConstants.EDIT_HOSPITAL_PROFILE)) && (
              <a onClick={(e: any): any => editHandleClick()}>
                {!isShowSaveComponent ? (
                  <Tooltip title={TOOLTIP_TEXT.edit}><EditIcon /></Tooltip>
                ) : (
                  <span className="error-text">
                    <Tooltip title={TOOLTIP_TEXT.close}><CloseIcon className="fill-close" /></Tooltip>
                  </span>
                )}
              </a>
            )
          }
        >
          {!isShowSaveComponent &&
            profileData &&
            profileData.panCardHolderName &&
            profileData.panCardNumber &&
            bankData &&
            registrationData ? (
            <>
              <Row gutter={GUTTOR_SPACE_SMALL}>
                <Col md={8}>
                  <div className="label-title">Registration No.</div>
                  <p className="label-value text-capital text-wrap">
                    {registrationData.registrationNumber}
                  </p>
                </Col>
                <Col md={8}>
                  <div className="label-title">Registration authority</div>
                  <p className="label-value text-wrap">
                    <Tooltip title={registrationData.registrationAuthority} placement={'top'}>
                      {registrationData.registrationAuthority}
                    </Tooltip>
                  </p>
                </Col>
                {profileDetail?.rohiniId && profileDetail?.rohiniId !== '0' && profileDetail?.rohiniId?.trim() && (
                  <Col md={8}>
                    <div className="label-title">Rohini ID</div>
                    <p className="label-value">
                      {profileDetail.rohiniId}
                    </p>
                  </Col>
                )}
                <Col md={8}>
                  <div className="label-title">Start date</div>
                  <p className="label-value">
                    {moment(registrationData.registrationStartDate).format(
                      COMMON_DATE_FORMAT,
                    )}
                  </p>
                </Col>
                <Col md={8}>
                  <div className="label-title">End date</div>
                  <p className="label-value">
                    {moment(registrationData.registrationEndDate).format(
                      COMMON_DATE_FORMAT,
                    )}
                  </p>
                </Col>

                <Col md={8}>
                  <div className="label-title">PAN card No.</div>
                  <p className="label-value text-capital">
                    {profileData.panCardNumber}
                  </p>
                </Col>
                <Col md={8}>
                  <div className="label-title">Name on pan card</div>
                  <p className="label-value text-capitalize text-wrap">
                    <Tooltip title={profileData.panCardHolderName}>
                      {profileData.panCardHolderName}
                    </Tooltip>
                  </p>
                </Col>
                <Col md={8}>
                  <div className="label-title">Account No.</div>
                  <p className="label-value text-wrap">
                    {bankData.accountNumber}
                  </p>
                </Col>
                <Col md={8}>
                  <div className="label-title">Account holder name</div>
                  <p className="label-value text-capitalize text-wrap">
                    <Tooltip title={bankData.accountHolderName}>
                      {bankData.accountHolderName}
                    </Tooltip>
                  </p>
                </Col>
                <Col md={8}>
                  <div className="label-title">IFSC code</div>
                  <p className="label-value text-capital">
                    {bankData.ifscCode}
                  </p>
                </Col>
                <Col md={8}>
                  <div className="label-title">Bank name</div>
                  <Tooltip title={bankData.bankName}>
                    <p className="label-value">{bankData.bankName}</p>
                  </Tooltip>
                </Col>
                <Col md={profileDetail?.rohiniId ? 8 : 16}>
                  <div className="label-title">Bank address</div>
                  <p className="label-value mb-0 text-elipsis text-wrap">
                    <Tooltip title={bankData.bankAddress}>
                      {bankData.bankAddress}
                    </Tooltip>
                  </p>
                </Col>
              </Row>
            </>
          ) : (
            !isShowSaveComponent &&
            !profileData &&
            !isNewEntry && <Skeleton active={true} />
          )}
          {(isShowSaveComponent ||
            (profileData &&
              ((profileData.bankDetails &&
                profileData.bankDetails.length === 0) ||
                (profileData.registrationDetails &&
                  profileData.registrationDetails.length === 0) ||
                !profileData.panCardHolderName ||
                !profileData.panCardNumber))) && (
              <SaveAccountDetail data={profileData} onCancel={editHandleClick} />
            )}
          {isNewEntry && (
            <div>
              Please create a profile by clicking{' '}
              <strong>Hospital Details</strong> tab above{' '}
            </div>
          )}
        </Panel>
      </Col>
    </Row>
  );
};
export default AccountDetail;
